export const Wordmark = ({ good = "text-2xl", esp = "text-[0.55rem]", gap = "mt-1", className = "", testid }) => (
  <div className={`flex flex-col items-start leading-none select-none ${className}`} data-testid={testid}>
    <span className={`font-display font-extrabold uppercase tracking-tight text-[#D4AF37] ${good}`}>
      Good Shot
    </span>
    <span className={`font-display font-medium uppercase text-white/90 ${esp} ${gap}`} style={{ letterSpacing: "0.55em" }}>
      Espresso
    </span>
  </div>
);
